export const sphinxEndpoints = {
    download: {
        api: '/secure/proxy', //system/bucketname/filename
        method: 'GET',
        parameter: true
    },
    proxy: {
        api: '/proxy', //system/bucketname/filename
        method: 'GET',
        parameter: true
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/sphinx.endpoints.ts